const getHtml = () => {
  return `
        <div>
          <h1>title</h1>
          <div>
            <p>This is the body of secondary Text</p>
          </div>
        </div>
      `;
};

const getCss = () => {
  return ``;
};

const getJs = () => {
  return ``;
};

const SecondaryText = { getHtml, getCss, getJs };

export default SecondaryText;
